import { Typography } from "@/components/app";
import { Certified, SecurePayment, Trusted } from "../icons/customIcons";
import { motion } from "framer-motion";
import {
  fadeDown,
  fadeLeft,
  fadeRight,
  fadeUp,
  scaleIn,
  staggerContainer,
  viewportOnce,
} from "@/lib/animations";

const trustIndicators = [
  {
    icon: <SecurePayment />,
    label: "Secure Payments",
  },
  {
    icon: <Certified />,
    label: "Certified Jewellery",
  },
  {
    icon: <Trusted />,
    label: "Trusted by 10,000+",
  },
];

export function HeroSection() {
  return (
    <section id="home" className="pb-6 md:pb-10 lg:pb-12 pt-6 md:pt-0">
      <div className="wrapper">
        <div className="overflow-hidden relative z-1 flex flex-wrap lg:after:block after:hidden after:content-[''] after:absolute after:right-0 after:-bottom-4 after:bg-[url('/images/hero-section.webp')] after:bg-contain after:bg-bottom after:z-1 after:h-full after:w-1/2 after:bg-no-repeat  ">
          {/* Left Content */}
          <div className="w-full lg:w-3/5 order-2 lg:order-1 relative  ">
            <motion.div
              className="lg:space-y-6 space-y-4 relative xl:p-16 lg:p-12 py-6 px-5 lg:rounded-l-3xl lg:rounded-t-none lg:rounded-br-none rounded-b-3xl bg-primary overflow-hidden"
              variants={staggerContainer}
              initial="hidden"
              animate="visible"
            >
              <div className="space-y-3">
                {/* Badge */}
                <motion.div
                  variants={fadeDown}
                  className="inline-flex items-center gap-2 w-fit md:px-5 md:py-4 px-4 py-2.5 rounded-full bg-white/15 md:min-h-[55px]"
                >
                  <span>
                    <img
                      src="/images/heor-badge-vector.svg"
                      className="w-6 h-6"
                      alt="badge"
                    />
                  </span>
                  <Typography
                    variant="caption"
                    className="font-semibold text-white"
                  >
                    India's Trusted Jewellery App
                  </Typography>
                </motion.div>

                <motion.h1
                  variants={fadeUp}
                  className="text-white font-semibold leading-snug"
                  style={{ fontSize: "clamp(24px, 61px, 3.5vw)" }}
                >
                  Buy Gold & Silver Jewellery Online with Confidence
                </motion.h1>

                <motion.div variants={fadeUp}>
                  <Typography variant="h4" className="text-white text-balance">
                    Discover elegant jewellery collections, track gold prices in
                    real time, and shop securely from your phone.
                  </Typography>
                </motion.div>
              </div>

              {/* CTA Buttons */}
              <motion.div variants={fadeUp} className="flex flex-wrap gap-4">
                <a
                  href={import.meta.env.VITE_APPLE_APP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block border rounded-lg overflow-hidden"
                >
                  <img
                    src="/images/apple-store.webp"
                    alt="ios store"
                    className="md:w-[192px] w-auto h-10 md:h-[57px]"
                  />
                </a>
                <a
                  href={import.meta.env.VITE_ANDROID_APP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block border rounded-lg overflow-hidden"
                >
                  <img
                    src="/images/play-store.webp"
                    alt="play store"
                    className="md:w-[192px] w-auto h-10 md:h-[57px]"
                  />
                </a>
              </motion.div>

              {/* Trust Indicators */}
              <motion.div
                variants={staggerContainer}
                className="flex flex-wrap gap-4 md:pt-4 pt-3"
              >
                {trustIndicators.map((indicator, index) => (
                  <motion.div
                    key={index}
                    variants={fadeUp}
                    className="flex items-center gap-2 lg:border-r-2 border-white/20 last:border-0 w-max lg:pr-4"
                  >
                    <div className="w-12 h-12 border rounded-[16px] flex items-center justify-center bg-background text-primary">
                      {indicator.icon}
                    </div>
                    <Typography
                      variant="caption"
                      className="font-semibold text-background"
                    >
                      {indicator.label}
                    </Typography>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>

            <div className="w-20 hidden md:block md:w-auto absolute bottom-28 right-14 z-10">
              <img src="/images/banner-arrow.svg" alt="arrow" />
            </div>
          </div>

          {/* Right Image */}
          <div className="w-full order-1 lg:order-2 lg:max-w-2/5">
            <div className="lg:rounded-r-3xl rounded-t-3xl lg:rounded-t-none bg-primary overflow-hidden h-full xl:pt-16 lg:pt-12 pt-5  flex items-end justify-end">
              <motion.img
                src="/images/hero-section.webp"
                alt="hero"
                className="lg:hidden max-h-full object-contain relative z-1 w-auto mx-auto -mb-4"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.8,
                  delay: 0.3,
                  ease: [0.22, 1, 0.36, 1],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
